function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5716\\u5C64_2",
  "data-name": "\\u5716\\u5C64 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M2.3,89.63C-.76,81-1,72.81,3.82,60.81c11-27.43,40-33.42,66.35-35.6q32-2.64,64-6.11c27.76-3.05,55.18-8.3,82.78-12.44,12.62-1.9,25-5.64,37.79-6.26,11.19-.55,41.51-2.06,48.6,8.67,6.09,9.21-1.75,23.12-6.39,31.07,0,0-17,39-75,75-10.36,7.4-20.51,15.13-30.46,23.07-12,9.59-26,18.27-34.78,31.23-9.35,13.85-14.82,28.68-26.3,41.51-8.09,9-17.64,17.06-28.79,22-15.61,6.93-30.3,2.59-45.76-2.31-15.23-4.81-44.11-11.2-52.64-27.08-9.15-17,3.24-41.15,11.23-55.92,0,0,13-9-4-41C7.05,100.22,4.16,94.85,2.3,89.63Z"
}));

function SvgBackgroundW4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 305.57 236.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundW4);
export default __webpack_public_path__ + "static/media/background-w-4.aeb0911f.svg";
export { ForwardRef as ReactComponent };